// extracted by mini-css-extract-plugin
export default {"card_wrap":"CardWrap_card_wrap__PQ4GM"};